<template>
	<div class="row all-venue-stats">
		<div class="col-12 col-md-8 order-1 order-md-0">
			<div class="container">

				<div class="row">
					<div class="col-6 text-center text-md-left p-1 py-3">
						<div class="w-100 value">{{data.latest_audit_diff ? data.latest_audit_diff : '-'}}</div>
						<div class="w-100">Last audited</div>
					</div>
					<div class="col-6 text-center text-md-left p-1 py-3">
						<div class="w-100 value">{{data.num_audits_this_year}}</div>
						<div class="w-100">Audits completed (selected year)</div>
					</div>
					<div class="col-6 text-center text-md-left p-1 py-3">
						<div class="w-100 value">{{data.num_audits_this_month}}</div>
						<div class="w-100">Audits completed this month</div>
					</div>
					<div class="col-6 text-center text-md-left p-1 py-3">
						<div class="w-100 value">{{data.max_audits_per_auditor.value ? data.max_audits_per_auditor.value : '-'}}</div>
						<div class="w-100" v-if="data.max_audits_per_auditor.name">Audits (selected year) by {{data.max_audits_per_auditor.name}}</div>
						<div class="w-100" v-else>No audits found</div>
					</div>
				</div>

			</div>
		</div>
		<div class="col-12 col-md-4 text-center order-0 order-md-1 p-0 my-auto">
			<div class="w-100 text-right p-1">
				<a v-if="data.schedule == null" :href="schedule_url" class="btn btn-primary">Schedule Audit Appointment</a>
				<a v-else class="btn btn-primary" :href="schedule_edit_url.replace('?', data.schedule.id)">Edit {{data.schedule.formatted_date.day +  ' ' + data.schedule.formatted_date.month}} schedule</a>
			</div>
			<div class="w-100 text-right p-1">
				<button v-bind:disabled="downloading_pdf" v-on:click="exportPDF()" class="btn btn-primary justify-content-center d-inline-flex">Export PDF Report <div v-if="downloading_pdf" class="loaders--button"></div></button>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props:[
			'data', 'schedule_url', 'schedule_edit_url', 'downloading_pdf'
		],

		mounted() {
			
		},

		methods: {
			exportPDF(){
				this.$emit('export_pdf', true);
			}
		},
	}
</script>
